(() => {
  document.documentElement.classList.remove('no-js');

  const updateProductGalleryImage = (thumbnail) => {
    const gallery = thumbnail.closest('.jf-product__media');
    const mainImage = gallery && gallery.querySelector('.jf-product__media-main img');
    if (!mainImage) return;

    const nextSrc = thumbnail.getAttribute('data-image-src');
    const nextAlt = thumbnail.getAttribute('data-image-alt');

    if (nextSrc) {
      mainImage.src = nextSrc;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
    }

    if (nextAlt) mainImage.alt = nextAlt;

    gallery.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
      button.classList.remove('is-active');
      button.setAttribute('aria-current', 'false');
    });

    thumbnail.classList.add('is-active');
    thumbnail.setAttribute('aria-current', 'true');
  };

  const handleProductGalleryClick = (event) => {
    const thumbnail = event.target.closest('[data-product-thumbnail]');
    if (thumbnail) {
      event.preventDefault();
      event.stopPropagation();
      updateProductGalleryImage(thumbnail);
      return;
    }

    const mainImage = event.target.closest('[data-product-main-image]');
    if (!mainImage) return;

    const gallery = mainImage.closest('.jf-product__media');
    const thumbnails = gallery
      ? Array.from(gallery.querySelectorAll('[data-product-thumbnail]:not([aria-hidden="true"])'))
      : [];

    if (thumbnails.length < 2) return;

    event.preventDefault();
    event.stopPropagation();

    const currentIndex = thumbnails.findIndex((button) => button.classList.contains('is-active'));
    const nextIndex = currentIndex >= 0 ? (currentIndex + 1) % thumbnails.length : 0;
    updateProductGalleryImage(thumbnails[nextIndex]);
  };

  const scrollCarousel = (control) => {
    const root = control.closest('[data-carousel]');
    const track = root && root.querySelector('[data-carousel-track]');
    if (!track) return;

    const direction = control.getAttribute('data-carousel-control') === 'next' ? 1 : -1;
    const firstItem = track.firstElementChild;
    const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
    const step = firstItem ? firstItem.getBoundingClientRect().width + gap : Math.max(260, track.clientWidth * 0.75);
    const maxScroll = track.scrollWidth - track.clientWidth;
    let nextLeft = track.scrollLeft + direction * step;

    if (nextLeft < 0) nextLeft = maxScroll;
    if (nextLeft > maxScroll - 2) nextLeft = 0;

    track.scrollTo({ left: nextLeft, behavior: 'smooth' });
  };

  let lastCarouselPointerAt = 0;

  const handleCarouselControl = (event) => {
    const control = event.target.closest('[data-carousel-control]');
    if (!control) return;

    event.preventDefault();
    event.stopPropagation();
    lastCarouselPointerAt = Date.now();
    scrollCarousel(control);
  };

  document.addEventListener('pointerdown', handleProductGalleryClick, true);
  document.addEventListener('pointerdown', handleCarouselControl, true);

  document.querySelectorAll('[data-drawer-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const drawer = document.querySelector(button.getAttribute('data-drawer-open'));
      if (drawer) drawer.classList.add('is-open');
    });
  });

  document.querySelectorAll('[data-drawer-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const drawer = button.closest('.jf-drawer');
      if (drawer) drawer.classList.remove('is-open');
    });
  });

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-carousel-control]');
    if (control) {
      if (Date.now() - lastCarouselPointerAt > 700) scrollCarousel(control);
      return;
    }

    const accordionButton = event.target.closest('[data-accordion-button]');
    if (accordionButton) {
      const item = accordionButton.closest('.jf-accordion__item');
      if (item) item.classList.toggle('is-open');
    }

    const quantityButton = event.target.closest('[data-quantity]');
    if (quantityButton) {
      const wrapper = quantityButton.closest('.jf-quantity');
      const input = wrapper && wrapper.querySelector('input');
      if (!input) return;

      const step = quantityButton.getAttribute('data-quantity') === 'plus' ? 1 : -1;
      input.value = Math.max(0, Number(input.value || 0) + step);

      const form = quantityButton.closest('form');
      if (form) form.submit();
    }
  });

 const formatCountdown = (remaining) => {
  const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

const getStoredCountdownEnd = (key) => {
  try {
    return Number(localStorage.getItem(key) || 0);
  } catch (error) {
    return 0;
  }
};

const setStoredCountdownEnd = (key, value) => {
  try {
    localStorage.setItem(key, String(value));
  } catch (error) {}
};

document.querySelectorAll('[data-countdown-minutes]').forEach((node, index) => {
  const minutes = Math.max(1, Number(node.getAttribute('data-countdown-minutes') || 5));
  const duration = minutes * 60 * 1000;
  const storageKey = node.getAttribute('data-countdown-key') || `jf-countdown-${index}-${minutes}`;
  let end = getStoredCountdownEnd(storageKey);

  if (!end || end <= Date.now()) {
    end = Date.now() + duration;
    setStoredCountdownEnd(storageKey, end);
  }

  const tick = () => {
    let remaining = end - Date.now();

    if (remaining <= 0) {
      end = Date.now() + duration;
      setStoredCountdownEnd(storageKey, end);
      remaining = duration;
    }

    node.textContent = formatCountdown(remaining);
  };

  tick();
  setInterval(tick, 1000);
});
document.addEventListener('click', (event) => {
    const cookieLink = event.target.closest('[data-cookie-preferences]');
    if (!cookieLink) return;

    if (
      window.Shopify &&
      Shopify.customerPrivacy &&
      typeof Shopify.customerPrivacy.showPreferences === 'function'
    ) {
      event.preventDefault();
      Shopify.customerPrivacy.showPreferences();
    }
  });
})();